import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { BcModalComponent } from '@bancolombia/design-system-web/bc-modal';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AzureAdAccountModel } from 'src/app/domain/models/azure-ad/account.model';
import { AddAzureAccount } from 'src/app/infrastructure/store/azure-ad/account.actions';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @ViewChild('confirmacionlogout', { static: false })
  confirmacionModal!: BcModalComponent;

  nombre: string;
  azureAccount: Observable<AzureAdAccountModel>;
  //Usuario asignado cuando la aplicacion ingresa por ambiente DEV o QA
  nombreTest = 'Test';

  // modal Confirmacion
  confirmAction: boolean = true;
  confirmDisplayButton: boolean = true;
  confirmOuterCloseTap: boolean = true;
  confirmSubTitle = 'Realmente desea cerrar la sesión?';
  confirmButtonAlignment: any = 'horizontal';
  //fin modal Confirmacion

  authServicePrivate: MsalService;

  constructor(private authService: MsalService, private store: Store, private router: Router,
    private _ngZone: NgZone) {
    this.azureAccount = this.store.select(state => state.account);
    this.nombre = 'No especificado';
    this.authServicePrivate = this.authService;
  }

  ngOnInit(): void {
    this.addAzureAdAccountToStorage();
    this.obtenerNombreUsuario();
  }

  addAzureAdAccountToStorage() {
    this.store.dispatch(new AddAzureAccount(this.authService.instance.getAllAccounts()[0]));
  }

  obtenerNombreUsuario() {
    this.azureAccount.subscribe({
      next: data => {
        this.nombre = data.name == null ? this.nombreTest : data.name!;
      }
    });
  }

  confirmacion() {
    this.confirmacionModal.openModal();
  }

  // Modal Confirmacion cambio de estado si/no
  handleModalLogout(event: any) {
    switch (Number(event)) {
      case 0: {
        this.confirmacionModal.shutDown();
      }
        break;
      case 1: {
        this.confirmacionModal.shutDown();
        this.authServicePrivate.logoutRedirect();
        sessionStorage.removeItem("ultimaConexion");
      }
        break;
    }
  }

}
